import React from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import Analytics from '../../../analytics';
import {canShowSqftButtonForFeature} from "../../../misc/helpers";
import {enableSquareFootage, setSqftFromFeature} from "../../../actions/sqftFunctions";
import {featureInterface} from "../../../interfaces/featureInterface";
import {setCameFromPage} from "../../../actions/actionFunctions";

const MaterialsWizardSqftButton = (props) => {

  const {fabricatorSettings, enableSquareFootage, activeFeature, setCameFromPage, setSqftFromFeature} = props;

  if (!canShowSqftButtonForFeature({partId: "countertop"}, fabricatorSettings)) {
    return null
  }

  const handleSQFTButtonClick = () => {
    Analytics.sendClickEvent("wizard-sqft-opened");
    if (activeFeature) {
      setCameFromPage(activeFeature);
      setSqftFromFeature({cartFeature: activeFeature})
    }
    enableSquareFootage(true);
  };

  return (
    <button className="ui-button ui-button--sqft ui-button--sqft--small"
            onClick={handleSQFTButtonClick}>
      <FormattedMessage id="quotingTool.featureInfo.sqftButton"/>
    </button>
  )

}

MaterialsWizardSqftButton.propTypes = {
  feature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const settings = store.fabricatorState.settings;
  return {
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
  enableSquareFootage,
  setCameFromPage,
  setSqftFromFeature,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsWizardSqftButton)
